import {
    StackerAPI,
    StackerActions,
    FETCH_STARTED,
    FETCH_COMPLETED,
    byID,
    without,
    fetchAndReturn,
    acceptHeaders,
} from "./utils/utils"
import { unique } from "utils/utils"
import { STACK_SELECTED } from "./stackApi"

// CONSTANTS
export const PAGES_FETCHED = "PAGES_FETCHED"
export const PAGE_CREATED = "PAGE_CREATED"
export const PAGE_UPDATED = "PAGE_UPDATED"
export const PAGE_REMOVED = "PAGE_REMOVED"

// API
class PageApi extends StackerAPI {
    path = "pages/"

    transformFromLocal = data => {
        const keys = Object.keys(data)
        let out = {}
        keys.forEach(key => {
            if (key.indexOf("options.") === -1) {
                out[key] = data[key]
            } else {
                const keyName = key.split(".")[1]
                out.options = { ...out.options, [keyName]: data[key] }
            }
        })
        return out
    }
}
const pageApi = new PageApi()

class PageActions extends StackerActions {
    api = pageApi
    reducer = "pages"
    actionTypes = {
        fetched: PAGES_FETCHED,
        removed: PAGE_REMOVED,
        created: PAGE_CREATED,
        updated: PAGE_UPDATED,
    }
}
let PA = new PageActions()
PA.actions = { ...PA.actions, fetchByObject: PA.fetchByObject }
export const pageActions = PA.actions

export const getPageThumb = pageId => {
    return fetchAndReturn(`thumbnails/${pageId}/`)
}

// STATE
const initialState = {
    pages: [],
    entities: {},
    fetching: [],
}

// REDUCERS
export function pageReducer(state = initialState, action) {
    var pages, page, fetching
    switch (action.type) {
        case PAGES_FETCHED:
            return {
                ...state,
                pages: unique([...state.pages, ...action.payload.map(page => page._sid)]),
                entities: { ...state.entities, ...byID(action.payload) },
            }
        case PAGE_CREATED:
            pages = [...state.pages, [action.payload._sid]]
            return {
                ...state,
                pages,
                entities: { ...state.entities, [action.payload._sid]: action.payload },
            }
        case PAGE_UPDATED:
            page = { ...state.entities[action.id], ...action.payload }
            return {
                ...state,
                entities: { ...state.entities, [page._sid]: page },
            }
        case PAGE_REMOVED:
            pages = state.pages.map(pages => without(pages, action.id))
            return {
                ...state,
                pages,
            }

        case FETCH_STARTED:
            return { ...state, fetching: [...state.fetching, action.key] }
        case FETCH_COMPLETED:
            fetching = state.fetching.filter(item => item !== action.key)
            return { ...state, fetching: fetching }

        case STACK_SELECTED:
            return initialState
        default:
            return state
    }
}

// SELECTORS
export const getPageEntities = state => state.pages.entities
export const getPages = state => {
    if (typeof state.pages.pages.map !== "function") debugger
    return state.pages.pages.map(pageId => state.pages.entities[pageId])
}

// HELPERS



// WEBPACK FOOTER //
// ./src/data/pageApi.js